import dayjs from 'dayjs';

export function getDefaultFilter(): string {
  const threeMonthAgo = dayjs().subtract(3, 'month').startOf('day').unix();
  const today = dayjs().endOf('day').unix();

  return `${threeMonthAgo}, ${today}`;
}
